module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div id=\"")
    ; __append(escapeFn( node.id ))
    ; __append("\" parent=\"")
    ; __append(escapeFn( node.parent && node.parent.id ))
    ; __append("\" class=\"group-container node\">\n    <div class=\"group-header\">\n        <div class=\"table w100\">\n            <div>\n                <div style=\"width: 30%; text-align: left\">\n                    ")
    ;  widget.conditions.forEach(function(condition) { 
    ; __append("\n                    <button class=\"btn btn-blue ")
    ; __append(escapeFn( node.data.condition === condition.name ? "active" : "" ))
    ; __append("\" on-click=\"onConditionClick\" condition=\"")
    ; __append(escapeFn( condition.name ))
    ; __append("\">")
    ; __append(escapeFn( condition.label ))
    ; __append("</button>\n                    ")
    ;  }) 
    ; __append("\n                </div>\n                <div style=\"text-align: right\">\n                    <button class=\"btn btn-green\" on-click=\"onAddRuleClick\">Добваить правило</button>\n                    <button class=\"btn btn-green\" on-click=\"onAddGroupClick\">Добваить группу</button>\n                    ")
    ;  if (!node.isRoot()) { 
    ; __append("\n                    <button class=\"btn btn-red\" on-click=\"onRemoveClick\">Удалить</button>\n                    ")
    ;  } 
    ; __append("\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"group-body\">\n        <div class=\"rules-list\"></div>\n    </div>\n</div>")
  }
  return __output.join("");

}